import axiosInstance from '@/services/axiosInstance'

export const apiLogin = async (username: string, password: string) => {
  const response = await axiosInstance.post(`/api/v1/auth/login`, {
    username,
    password,
  })
  return response.data
}

export const apiRefreshToken = async (refreshToken: string) => {
  const response = await axiosInstance.post(`/api/v1/auth/refresh-token`, {
    refresh_token: refreshToken,
  })
  return response.data
}
